export const ROOT = "/";
export const VOLUME_OVERLAY_TABLE = "/volumeOverlayTable";
export const DRIVER_MANAGEMENT = "/driverManagement";
export const PLAN_MANAGEMENT = "/planManagement";
export const ROUTE_MANAGEMENT = "/routeManagement";
export const SECTION_MANAGEMENT = "/sectionManagement";
export const SHIFT_MANAGER_MANAGEMENT = "/shiftManagerManagement";
